// Pick the richest <title> that still fits a length budget. Candidates
// most-informative first; the first within `max` wins, else the last
// non-empty (shortest) fallback. Keeps titles specific without blowing past
// what a SERP shows (~60 chars).
export const pickTitle = (candidates, max = 60) => {
  const list = (candidates || []).filter(Boolean);
  return list.find((c) => c.length <= max) || list[list.length - 1] || "";
};
